import { render, staticRenderFns } from "./word-manager-form.vue?vue&type=template&id=5926e0dc&scoped=true"
import script from "./word-manager-form.ts?vue&type=script&lang=ts&external"
export * from "./word-manager-form.ts?vue&type=script&lang=ts&external"
import style0 from "./word-manager-form.less?vue&type=style&index=0&id=5926e0dc&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5926e0dc",
  null
  
)

export default component.exports